// extracted by mini-css-extract-plugin
module.exports = {"categoryName":"PlayerOverall_categoryName__3_rJu","cycle":"PlayerOverall_cycle__3SUOk"};